export const convertTransactionTypeCount = (
  transactionTypeList,
  count,
  currentTransactionType = null
) => {
  const total = Object.keys(count).reduce(
    (sum, currentCount) => sum + count[currentCount],
    0
  );

  const convertedCount = transactionTypeList.map((transactionType) => {
    const key = Object.keys(count).find(
      (key) => key.toLowerCase() === transactionType.value
    );
    return {
      ...transactionType,
      count: transactionType.value === "semua" ? total : count[key] || 0,
      active: transactionType.value === currentTransactionType ? true : false,
    };
  });
  return convertedCount;
};
